import { FC, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Text, Checkbox, Select, Button, Input, Label, useId, Switch, Toaster, useToastController, Toast, ToastTitle, ToastBody, Field } from "@fluentui/react-components";

import { statesArray } from "../states";
import { useForm, Controller } from "react-hook-form";
import { accessTokenInfo$ } from "../oauth/oauth";
import { nodeServer } from "../constants";
import { useGeneralStyles } from "../styles";
import { IMember } from "../store/member";
import bcryptjs from "bcryptjs";
import FormInput from "../utility/FormInput";
import { userStore } from "../store/userStore";

interface MainProps {
    member: IMember;
    readonly: boolean;
    payMethod?: string;
    membershipCost?: number;
}


const MemberForm: FC<MainProps> = (props) => {

    const {
        handleSubmit,
        control,
        register,
        watch,
        setValue,
        formState: { errors },
    } = useForm<IMember>({
        mode: "onChange",
        //resetOptions:{keepDefaultValues:true},
        // values: editedValues,
        defaultValues: props.member,
        // defaultValues: useMemo(() => {
        //   console.log("MEMBER FORM PROPS");
        //     console.log(props.member);
        //     return props.member;
        // }, [props]),
    });

   

    useEffect(() => {
        Object.keys(props.member).forEach((key: any) => {
            setValue(key, props.member[key]);
        });
        //reset(props.member);
    }, [props.member, setValue]);

    const navigate = useNavigate();

    const watchPrivacy = watch("weblist");
    const watchEmailConsent = watch("emailconsent");
    useEffect(() => {
        watchPrivacy ? setprivacyLabel("Yes, include my name.") : setprivacyLabel("No, do NOT include my name.");
        watchEmailConsent ? setemailConsentLabel("Yes, send me emails.") : setemailConsentLabel("No, do NOT send me emails.");
    }, [watchPrivacy, watchEmailConsent]);

    const [privacyLabel, setprivacyLabel] = useState<string>("No, do NOT include my name.");
    const [emailConsentLabel, setemailConsentLabel] = useState<string>("No, do NOT send me emails.");
    //const [loginError, setLoginError] = useState<string>("");

    const generalStyles = useGeneralStyles();

    const toasterId = useId("toaster");
    const { dispatchToast } = useToastController(toasterId);
    const notify = (type: "error" | "success", message: string) => {
        if (type === "error") {
            dispatchToast(
                <Toast>
                    <ToastTitle>Error</ToastTitle>
                    <ToastBody>{message}</ToastBody>
                </Toast>,
                { intent: "error" }
            );
        } else {
            dispatchToast(
                <Toast>
                    <ToastTitle>Success</ToastTitle>
                </Toast>,
                { intent: "success" }
            );
        }
    };

    const onSubmit = async (values: IMember) => {
        console.log(values);
        //setLoginError("");

        if (props.member?.id !== undefined) {
            values.id = props.member?.id;
        }

        values.payby = props.payMethod;
        values.amount = props.membershipCost;

        const headers = new Headers();
        if (accessTokenInfo$.value != null && accessTokenInfo$.value.accessToken != null) {
            //console.log("Access token: " + accessTokenInfo$.value.accessToken);
            headers.append("Authorization", "Bearer " + accessTokenInfo$.value.accessToken);
        }

        if (values.password) {
            const salt = await bcryptjs.genSalt(10);
            const hash = await bcryptjs.hash(values.password, salt);
            const compare = await bcryptjs.compare(values.password, hash);
            //console.log({ salt: salt, hash: hash, compare: compare });
            if (compare) {
                values.hash = hash;
            } else {
                console.log("FAILED HASH CREATION - do not create new member");
                return;
            }
            delete values.password;
            delete values.password_confirmation;
        }

        //p.append("access_token", accessTokenInfo$.value.accessToken);

        headers.append("Content-Type", "application/json");

        if (values.id) {
            //update member
            let updatedMember = JSON.parse(JSON.stringify(values));
            delete updatedMember.admin;
            delete updatedMember.id;
            delete updatedMember.password_confirmation;
            const response = await fetch(nodeServer + `member/${values.id}`, {
                method: "put",
                body: JSON.stringify(updatedMember),
                headers: headers,
            });
            const result = await response.json();
            console.log(result);
            if (result.error) {
                notify("error", result.error);
            } else {
                userStore.refresh();
                notify("success", "Member updated successfully.");
            }
        } else {
            //new member
            const response = await fetch(nodeServer + "member", {
                method: "post",
                body: JSON.stringify(values),
                headers: headers,
            });
            const result = await response.json();
            console.log(result);
            if (result.error) {
                if (result.error.includes("Duplicate")) {
                    notify("error", "This username is already taken.");
                } else {
                    notify("error", result.error);
                }
            } else {
                notify("success", "Member created successfully.");
                if (props.payMethod !== undefined && props.payMethod !== null && props.payMethod !== "") {
                    if (props.payMethod === "online") {
                        window.open(`https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=${encodeURIComponent("memberfee@2yc3.org")}&item_name=${encodeURIComponent(result.member.institution)}_${encodeURIComponent(result.member.first)}_${encodeURIComponent(
                                                            result.member.last
                                                        )}&amount=${values.amount}`,
                                                        "_blank",
                                                        "rel=noopener noreferrer")?.focus();
                        navigate("/membership/onlinepayment?amount=" + props.membershipCost);
                    } else {
                        navigate("/membership/mailpayment?amount=" + props.membershipCost);
                    }
                }
            }
        }
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                }}
            >
                <form onSubmit={handleSubmit(onSubmit)} method="POST">
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 10,
                        }}
                    >
                        <Label>Current Memberships:</Label>
                        <Controller name="acs" control={control} render={({ field: { onChange, value } }) => <Checkbox onClick={(e)=>{if (props.readonly) e.currentTarget.checked = value}} readOnly={props.readonly} checked={value} onChange={onChange} label="ACS" />} />
                        <Controller name="divc" control={control} render={({ field: { onChange, value } }) => <Checkbox onClick={(e)=>{if (props.readonly) e.currentTarget.checked = value}} readOnly={props.readonly} checked={value} onChange={onChange} label="DivCHED" />} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.5em",
                        }}
                    >
                        
                            {props.readonly ? (
                                <FormInput label="Teaching Status" name="teacher" control={control} readonly={props.readonly} />
                            ) : (
                                <Field label="Teaching Status" required>
                                <Select {...register("teacher")}>
                                    <option value={"2-year college - Full-time"}>2-year college - Full-time</option>
                                    <option value={"2-year college - Adjunct"}>2-year college - Adjunct</option>
                                    <option value={"4-year college"}>4-year college</option>
                                    <option value={"High School"}>High School</option>
                                    <option value={"Other"}>Other</option>
                                    <option value={"Do not teach"}>Do not teach</option>
                                </Select>
                            </Field>
                            )}
                        

                        <FormInput name="first" control={control} label="First Name" required={true} readonly={props.readonly} />
                        <FormInput name="last" control={control} label="Last Name" required={true} readonly={props.readonly} />
                        <FormInput name="institution" control={control} label="Institution" required={true} readonly={props.readonly} />
                        <FormInput name="addr1" control={control} label="Address 1" required={true} readonly={props.readonly} />
                        <FormInput name="addr2" control={control} label="Address 2" required={false} readonly={props.readonly} />
                        <FormInput name="city" control={control} label="City" required={true} readonly={props.readonly} />

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                columnGap: "0.5em",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "0.5em",
                                    width: "100%",
                                }}
                            >
                                <Field label="State" required>
                                    {props.readonly ? (
                                        <Input {...register("st")} appearance="underline" readOnly />
                                    ) : (
                                        <Select {...register("st")}>
                                            {statesArray.map((v, i) => {
                                                return (
                                                    <option key={i} value={v.abbr}>
                                                        {v.name}
                                                    </option>
                                                );
                                            })}
                                        </Select>
                                    )}
                                </Field>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "0.5em",
                                    width: "100%",
                                }}
                            >
                                <FormInput name="zip" control={control} label="Zip" required={true} readonly={props.readonly} />
                            </div>
                        </div>

                        <FormInput
                            name="phone"
                            control={control}
                            label="Phone"
                            required={false}
                            readonly={props.readonly}
                            rules={{
                                pattern: {
                                    value: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})(.*?)?/i,
                                    message: "Use 123-456-7890 format. Extensions OK.",
                                },
                            }}
                            error={errors.phone}
                        />
                        <FormInput
                            name="email"
                            type="email"
                            control={control}
                            label="Email"
                            required={true}
                            readonly={props.readonly}
                            rules={{
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Invalid email address",
                                },
                            }}
                            error={errors.email}
                            autoComplete={"email"}
                        />
                    </div>

                    <div
                        style={{
                            marginTop: 20,
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.5em",
                        }}
                    >
                        <Text className={generalStyles.subtitle1}>Login Information</Text>

                        <FormInput name="username1" control={control} label="Username" required={true} readonly={props.readonly} autoComplete={"username"} />
                        <FormInput name="password" type="password" control={control} label="Password" required={true} readonly={props.readonly} autoComplete={props.member.id ? "current-password" : "new-password"} />

                        <FormInput
                            name="password_confirmation"
                            type="password"
                            control={control}
                            label="Confirm Password"
                            required={true}
                            readonly={props.readonly}
                            error={errors.password_confirmation}
                            rules={{
                                validate: (val) => {
                                    const password = watch("password");
                                    return password === val || "Passwords do NOT match.";

                                    // passwordEqual: (value, field) =>
                                    //   value === field.password || "Passwords do NOT match .",
                                },
                            }}
                            autoComplete={props.member.id ? "current-password" : "new-password"}
                        />
                    </div>

                    <div
                        style={{
                            marginTop: 20,
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.5em",
                        }}
                    >
                        <Text className={generalStyles.groupTitle}>Privacy Policy</Text>
                        <Text>
                            The 2YC3 lists current dues-paying members on the 2YC3 website.
                            <br />
                            The list includes names, institutional affiliation, and membership expiration date only.
                            <br />
                            Email addresses and phone numbers are NOT listed.
                        </Text>
                        <Switch {...register("weblist")} label={privacyLabel} readOnly={props.readonly} />
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.5em",
                        }}
                    >
                        <Text className={generalStyles.groupTitle}>Email Use Policy</Text>
                        <Text>
                            Giving 2YC3 consent for the use of your email address will allow us to send you relevant information via email.
                            <br />
                            Your email address will not be distributed to third parties.
                        </Text>

                        <Switch readOnly={props.readonly} label={emailConsentLabel} {...register("emailconsent")} />
                    </div>

                    {props.readonly || (
                        <Button type="submit" appearance="primary">
                            Submit
                        </Button>
                    )}
                    <Toaster toasterId={toasterId} />
                </form>
            </div>
        </>
    );
};

export default MemberForm;
